import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import { Input, RejectionReason, SelectWithSearch, VerifyComponent } from "components";
import { getUserRoles } from "modules/auth/slice";
import { EWALLET_NAME, PAYMENT_METHOD } from "../staticData";
import { getBanksNames, getMezzaCardNames } from "../config/api";

function PaymentInfo({
    newSupplierData,
    handleSupplierDetailsChange,
    isEditable,
    errorList,
    eWalletNumberError,
    isQARole,
    handleObjections,
    objections,
    isAuthorizedToCreate,
}) {
    const [allBanks, setAllBanks] = useState(null);
    const [objection, setObjections] = useState({});
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");

    const [allMezzaBanks, setAllMezzaBanks] = useState(null);
    const handleFetchBanksNames = async () => {
        const data = await getBanksNames();
        setAllBanks(data.map((name) => ({ label: name })));
    };
    const handleFetchMezzaCardNames = async () => {
        const data = await getMezzaCardNames();
        setAllMezzaBanks(data.map((name) => ({ label: name })));
    };

    useEffect(() => {
        handleFetchBanksNames();
        handleFetchMezzaCardNames();
    }, []);
    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            isEditable={isEditable}
                            isMulti={false}
                            label="Payment Method"
                            name="paymentMethod"
                            options={PAYMENT_METHOD}
                            handleChange={(value) =>
                                handleSupplierDetailsChange(value, "paymentMethod")
                            }
                            value={newSupplierData?.paymentMethod}
                            placeholder="Select"
                            errorMessage={errorList?.paymentMethod && errorList?.paymentMethod}
                            required
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("paymentMethod")}
                                handleVerify={() =>
                                    handleVerify(
                                        "paymentMethod",
                                        "Payment Method",
                                        "Payments Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.paymentMethod?.verified
                                        ? objection?.paymentMethod?.verified
                                        : false
                                }
                                objection={
                                    objection?.paymentMethod?.haveobjection
                                        ? objection?.paymentMethod?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Payment Method")}
                    </Row>
                    {objection?.paymentMethod?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Payment Method",
                                    "Payments Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                {newSupplierData?.paymentMethod && (
                    <FormGroup>
                        <Row>
                            <Input
                                isEditable={isEditable}
                                label="Bank/ account owner name"
                                name="accountHolderName"
                                type="text"
                                required
                                value={newSupplierData?.accountHolderName}
                                onChange={(e) => handleSupplierDetailsChange(e)}
                                placeholder="Ex: Mohamed ahmed ali"
                                errorMessage={
                                    errorList?.accountHolderName && errorList?.accountHolderName
                                }
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() =>
                                        openObjectionhandler("accountHolderName")
                                    }
                                    handleVerify={() =>
                                        handleVerify(
                                            "accountHolderName",
                                            "Account Holder",
                                            "Payments Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.accountHolderName?.verified
                                            ? objection?.accountHolderName?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.accountHolderName?.haveobjection
                                            ? objection?.accountHolderName?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Account Holder")}
                        </Row>
                        {objection?.accountHolderName?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Account Holder",
                                        "Payments Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                )}
            </FormRow>

            {newSupplierData?.paymentMethod?.value === "bank_account" && (
                <>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    isEditable={isEditable}
                                    isMulti={false}
                                    label="Bank Name"
                                    name="bankName"
                                    options={allBanks}
                                    handleChange={(value) =>
                                        handleSupplierDetailsChange(value, "bankName")
                                    }
                                    value={newSupplierData?.bankName}
                                    placeholder="Select"
                                    required
                                    errorMessage={errorList?.bankName && errorList?.bankName}
                                />
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("bankName")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "bankName",
                                                "Bank Name",
                                                "Payments Info - Supplier",
                                                "supplier_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.bankName?.verified
                                                ? objection?.bankName?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.bankName?.haveobjection
                                                ? objection?.bankName?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                                {renderObjection("Bank Name")}
                            </Row>
                            {objection?.bankName?.haveobjection && (
                                <Textarea
                                    autoFocus
                                    required
                                    onBlur={(e) => {
                                        handleObjections(
                                            e,
                                            "Bank Name",
                                            "Payments Info - Supplier",
                                            "supplier_profile",
                                            false
                                        );
                                    }}
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Input
                                    isEditable={isEditable}
                                    label="Bank Account Number"
                                    name="bankAccountNumber"
                                    type="text"
                                    required
                                    value={newSupplierData?.bankAccountNumber}
                                    onChange={(e) => handleSupplierDetailsChange(e)}
                                    placeholder="Ex: 0000000000000"
                                    errorMessage={
                                        errorList?.bankAccountNumber && errorList?.bankAccountNumber
                                    }
                                />
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("bankAccountNumber")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "bankAccountNumber",
                                                "Bank Account Number",
                                                "Payments Info - Supplier",
                                                "supplier_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.bankAccountNumber?.verified
                                                ? objection?.bankAccountNumber?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.bankAccountNumber?.haveobjection
                                                ? objection?.bankAccountNumber?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                                {renderObjection("Bank Account Number")}
                            </Row>
                            {objection?.bankAccountNumber?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) => {
                                        handleObjections(
                                            e,
                                            "Bank Account Number",
                                            "Payments Info - Supplier",
                                            "supplier_profile",
                                            false
                                        );
                                    }}
                                />
                            )}
                        </FormGroup>
                    </FormRow>

                    <FormRow>
                        <FormGroup>
                            <Row>
                                <Input
                                    isEditable={isEditable}
                                    label="IBAN Number"
                                    name="ibanNumber"
                                    type="text"
                                    required
                                    value={newSupplierData?.ibanNumber}
                                    onChange={(e) => handleSupplierDetailsChange(e)}
                                    placeholder="Ex: 0000000000000"
                                    errorMessage={errorList?.ibanNumber && errorList?.ibanNumber}
                                />
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("ibanNumber")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "ibanNumber",
                                                "Bank IBAN Number",
                                                "Payments Info - Supplier",
                                                "supplier_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.ibanNumber?.verified
                                                ? objection?.ibanNumber?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.ibanNumber?.haveobjection
                                                ? objection?.ibanNumber?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                                {renderObjection("Bank IBAN Number")}
                            </Row>
                            {objection?.ibanNumber?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) => {
                                        handleObjections(
                                            e,
                                            "Bank IBAN Number",
                                            "Payments Info - Supplier",
                                            "supplier_profile",
                                            false
                                        );
                                    }}
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                </>
            )}
            {newSupplierData?.paymentMethod?.value === "e_wallet" && (
                <FormRow>
                    <FormGroup>
                        <Row>
                            <SelectWithSearch
                                isEditable={isEditable}
                                isMulti={false}
                                label="E-Wallet Name"
                                name="eWalletName"
                                options={EWALLET_NAME}
                                handleChange={(value) =>
                                    handleSupplierDetailsChange(value, "eWalletName")
                                }
                                value={newSupplierData?.eWalletName}
                                placeholder="Select"
                                required
                                errorMessage={errorList?.eWalletName && errorList?.eWalletName}
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("eWalletName")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "eWalletName",
                                            "Wallet Name",
                                            "Payments Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.eWalletName?.verified
                                            ? objection?.eWalletName?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.eWalletName?.haveobjection
                                            ? objection?.eWalletName?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Wallet Name")}
                        </Row>
                        {objection?.eWalletName?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Wallet Name",
                                        "Payments Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Input
                                isEditable={isEditable}
                                label="E-wallet Number"
                                name="eWalletNumber"
                                type="text"
                                required
                                value={newSupplierData?.eWalletNumber}
                                onChange={(e) => handleSupplierDetailsChange(e)}
                                placeholder="Ex: 0000000000000"
                                errorMessage={
                                    errorList?.eWalletNumber
                                        ? errorList?.eWalletNumber
                                        : eWalletNumberError
                                }
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("eWalletNumber")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "eWalletNumber",
                                            "Wallet Number",
                                            "Payments Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.eWalletNumber?.verified
                                            ? objection?.eWalletNumber?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.eWalletNumber?.haveobjection
                                            ? objection?.eWalletNumber?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Wallet Number")}
                        </Row>
                        {objection?.eWalletNumber?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Wallet Number",
                                        "Payments Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                </FormRow>
            )}
            {newSupplierData?.paymentMethod?.value === "mezza_card" && (
                <FormRow>
                    <FormGroup>
                        <Row>
                            <SelectWithSearch
                                isEditable={isEditable}
                                isMulti={false}
                                label="Mezza Card Bank Name"
                                name="mezzaCardName"
                                options={allMezzaBanks}
                                handleChange={(value) =>
                                    handleSupplierDetailsChange(value, "mezzaCardName")
                                }
                                value={newSupplierData?.mezzaCardName}
                                placeholder="Select"
                                required
                                errorMessage={errorList?.mezzaCardName && errorList?.mezzaCardName}
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("mezzaCardName")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "mezzaCardName",
                                            "Meza Card Bank Name",
                                            "Payments Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.mezzaCardName?.verified
                                            ? objection?.mezzaCardName?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.mezzaCardName?.haveobjection
                                            ? objection?.mezzaCardName?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Meza Card Bank Name")}
                        </Row>
                        {objection?.mezzaCardName?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Meza Card Bank Name",
                                        "Payments Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Input
                                isEditable={isEditable}
                                label="Meeza Card Number"
                                name="meezaCardNumber"
                                type="text"
                                value={newSupplierData?.meezaCardNumber}
                                onChange={(e) => handleSupplierDetailsChange(e)}
                                required
                                placeholder="Ex: 0000000000000"
                                errorMessage={
                                    errorList?.meezaCardNumber && errorList?.meezaCardNumber
                                }
                            />
                            {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("meezaCardNumber")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "meezaCardNumber",
                                            "Meza Card Number",
                                            "Payments Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.meezaCardNumber?.verified
                                            ? objection?.meezaCardNumber?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.meezaCardNumber?.haveobjection
                                            ? objection?.meezaCardNumber?.haveobjection
                                            : false
                                    }
                                />
                            )}
                            {renderObjection("Meza Card Number")}
                        </Row>
                        {objection?.meezaCardNumber?.haveobjection && (
                            <Textarea
                                required
                                autoFocus
                                onBlur={(e) => {
                                    handleObjections(
                                        e,
                                        "Meza Card Number",
                                        "Payments Info - Supplier",
                                        "supplier_profile",
                                        false
                                    );
                                }}
                            />
                        )}
                    </FormGroup>
                </FormRow>
            )}
        </>
    );
}

export default PaymentInfo;
